import React from 'react';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Organicé todo mi año en una tarde. Nunca más llego sin saber qué hacer.',
  author: 'Julián M.'
}, {
  quote: 'Mis alumnos mejoraron en semanas.',
  author: 'Carla R.'
}, {
  quote: 'Ahora manejo grupos mixtos sin caos.',
  author: 'Santiago F.'
}];
export function TestimonialsStrip() {
  return <section className="bg-[#0F1F3D] py-12 border-y border-white/10" data-id="element-326">
      <div className="max-w-6xl mx-auto px-4" data-id="element-327">
        <h3 className="text-center text-gray-400 font-medium mb-8 uppercase tracking-widest text-sm" data-id="element-328">
          Lo que dicen los profes
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-329">
          {testimonials.map((t, i) => <div key={i} className="bg-[#0A1628] p-6 rounded-xl border border-white/5 relative" data-id="element-330">
              <Quote className="absolute top-4 right-4 text-white/5" size={40} data-id="element-331" />
              <p className="text-gray-300 italic mb-4 relative z-10" data-id="element-332">
                "{t.quote}"
              </p>
              <p className="text-[#C6F432] font-bold" data-id="element-333">— {t.author}</p>
            </div>)}
        </div>
      </div>
    </section>;
}